module.exports = __webpack_public_path__ + "static/media/DSC_0455 (3).2dafc4af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0455 (3).jpg
// module id = 667
// module chunks = 0